// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF

import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import CanvasZoom from '../label/canvas/CanvasZoom';

interface Props {
  imageBase64: string;
}

export default function PanZoomImage({ imageBase64 }: Readonly<Props>) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      // @ts-ignore: Panzoom is assumed to be globally available
      const panzoomInstance = window.panzoom(containerRef.current, {
        // Konfigurationsoptionen für Panzoom
        maxScale: 3,
        minScale: 0.5,
        // Weitere Optionen...
      });

      // Cleanup-Funktion, um Panzoom-Instanz bei Komponentendemontage zu entfernen
      return () => {
        panzoomInstance.dispose();
      };
    }
  }, []);

  return (
    <ImageContent>
      <div
        ref={containerRef}
        style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <StyledImage
          src={`data:image/jpeg;base64,${imageBase64}`}
          alt='Algorithm'
          data-testid='algorithms-result-image'
        />
      </div>
      <CanvasZoom />
    </ImageContent>
  );
}

const ImageContent = styled.div`
  margin: 1rem;
  width: calc(100% - 2rem);
  height: calc(100% - 2rem);
  position: relative;
  overflow: hidden;
`;
const StyledImage = styled.img`
  position: absolute;
  box-shadow: 0 0 25px -5px #00000099;
`;
